<template>
	<div class="templateEditor">

     <div class="first_hader">
        <div class="check_header">
            <el-steps :active="active" finish-status="success">
            <el-step :title="$t('other.a2934')" @click="next()"></el-step>
            <el-step :title="$t('other.a1242')" @click="next()"></el-step>
            <el-step :title="$t('other.a2935')" @click="next()"></el-step>
            <el-step :title="$t('other.a306')" @click="next()"></el-step>
            <el-step :title="$t('other.a85')" @click="next()"></el-step>
            <el-step :title="$t('other.a2936')" @click="next()"></el-step>
            </el-steps>

        </div>
        <div class="second_header">
            <div>
                {{$t('other.a238')}}
            </div>
            <div>
               <el-button class="btn" type="primary" @click="next(0)">{{$t('other.a2857')}}</el-button>
                <el-button class="btn" type="primary" @click="next(1)">{{$t('other.a2858')}}</el-button>
                <el-button class="btn" type="primary" >{{$t('other.a2932')}}</el-button>
                <el-button class="btn" type="primary" >{{$t('other.a216')}}</el-button>
                <el-button class="btn" type="primary" >{{$t('other.a146')}}</el-button>
            </div>
        </div>
    </div>
    
    <div class="order_Box">
          <div v-if="!childrenModel.length" class="no_data">
              <span class="desc" >{{$t('other.a1347')}}</span>
              
          </div>
         <div v-else class="item_wrapper" v-for="(item,indexOne) in childrenModel" :key="indexOne">
              <div  class="item_header_wrapper" >
              <div class="item_header">
                  <span class="header_item" @click="editor(item)">{{$t('other.a238')}}</span>
                  <span class="header_item" @click="deleteItemw(item,indexOne,index)">{{$t('other.a312')}}</span>
                  <span class="header_item" @click="deleteItemw(item,indexOne,index)">{{$t('other.a2933')}}</span>
              </div>
              <div class="main_content">
                  <div class="item_left">
                      <div class="pic_box">
                      <img style="width:100%" :src="item.images[0].image">
                        </div>
                        <div class="item_name">
                            {{item.name}}
                        </div>
                  </div>
                   <div class="item_right" v-if="active == '1'">
                       <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
                            <el-form-item :label="$t('other.a1943')" prop="name">
                                <el-input v-model="item.categoryId" :placeholder="$t('other.a1943')"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-form v-for="(ccp,index01) in item.attributes" :key="index01" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
                            <el-form-item :label="ccp.attributeName" prop="name">
                               
                                    
                                <el-input style="width:180px"  v-model="ccp.attributeValue" :placeholder="$t('other.a1943')"></el-input>
                               
                            </el-form-item>
                        </el-form>
                   </div>
                     <div class="item_right" v-if="active == '2'">
                      <el-input :autosize="{ minRows: 2, maxRows: 15}" type="textarea" v-model="item.description" placeholder=""></el-input>
                   </div>
                    <div class="item_right" v-if="active == '3'">
                      <el-input :autosize="{ minRows: 2, maxRows: 15}" type="textarea" v-model="item.description" placeholder=""></el-input>
                   </div>
                     <div class="item_right" v-if="active == '4'">
                         <div class="ttp" v-show="item.variations.length" v-for="(ttp,index09) in item.variations" :key="index09">
                          <div class="ttp_item">skuName：{{ttp.name }}</div>
                          <div class="ttp_item">Sku：{{ttp.variationSku }}</div>
                          <div class="ttp_item">{{$t('other.a310')}}：{{ttp.stock}}</div>
                          <div class="ttp_item">{{$t('other.a831')}}：{{ttp.price}}</div>
                      </div>
                      <div class="ttp" v-show="!item.variations.length" >
                          <div class="ttp_item">skuName：{{item.itemSku}}</div>
                          <div class="ttp_item">skuName：{{item.skuName}}</div>
                          <div class="ttp_item">{{$t('other.a310')}}：{{item.stock}}</div>
                          <div class="ttp_item">{{$t('other.a831')}}：{{item.price}}</div>
                      </div>
                   </div>
                     <div class="item_right" v-if="active == '5'">
                      <el-input :autosize="{ minRows: 2, maxRows: 15}" type="textarea" v-model="item.description" placeholder=""></el-input>
                   </div>

              </div>
              </div>
          

          </div>
          
          
    </div>      
	</div>
</template>

<script>
	import api from '../../../api/api'
	import utils from  '../../../utils/utils.js'
    import { mapState, mapMutations } from 'vuex'
import i18n from '@/i18n/i18n'

	export default {
		data() {
			return {
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')) ,
				userShopslazada:JSON.parse(localStorage.getItem('lazadashopId')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				lazadashopId: JSON.parse(localStorage.getItem('lazadashopId')),
                active:null,
				shophasAuthorization:JSON.parse(localStorage.getItem('shophasAuthorization')),
                shopOptions:[],
                siteOptions:[],
                dialogVisible:false,
                productName:'',
                checkedAll:false,
                siteValue:'all',
                modelId:'',
                options:[],
                massOptions:[{
                    label:this.$t('other.a2934'),
                    value:'1'
                },{
                    label:this.$t('other.a2937'),
                    value:'2'
                },{
                    label:this.$t('other.a1242'),
                    value:'3'
                },{
                    label:this.$t('other.a2903'),
                    value:'4'
                },{
                    label:this.$t('other.a85'),
                    value:'5'
                },],
                fixAttribute:'',
                value4:[],
                childrenModel:[],
                targetList:[],
                targetListCopy:[],
                getDataList:{
                    end:null,
                    name:null,
                    offset:15,
                    page:0,
                    shopIds:null,
                    start:null,
                    userId:JSON.parse(localStorage.getItem('userInfo')).userId

                },
                   pickerOptions2: {
                    shortcuts: [{
                    text: this.$t("other.a130"),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                    }, {
                    text: this.$t("other.a131"),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                    }, {
                    text: this.$t("other.a132"),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                    }]
                },
				
			}
		},
	
		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
                productIds: state => state.common.productIds
			}),

		},
		watch:{
            targetList(){
               
                let list=this.targetList.filter(p => {
                    if(p.checked03){
                        return p
                    }
                })

                this.targetListCopy=list

                 console.log('targetList',list)
            }
		},
        filters:{
            capitalize(country){
                const obj={
                    'all':i18n.t('other.a1408'),
                    'TH':i18n.t('other.a1305'),
                    'PH':i18n.t('other.a1306'),
                    'ID':i18n.t('other.a1307'),
                    'MY':i18n.t('other.a1308'),
                    'VN':i18n.t('other.a1310'),

                }

                return obj[country]
            }
        },
		created(){
			
			this.init()
			
		
			
		},
		methods: {

            ...mapMutations("common", [
                "SET_REGISTOR_FALSE",
            ]),


           
         

            target(item,index){
                console.log(item,index,this.childrenModel)
                if(!index){
                    this.targetList=[]
                    this.childrenModel.forEach(p => {
                        p.products.forEach(k => {
                            k.children.forEach(j => {
                                
                                j.checked03=!j.checked03
                                this.targetList.push(j)
                            })
                        })
                    })

                    return
                }
                this.targetList.push(item)
                console.log(item,index)
            },


			init(){
				if(this.shophasAuthorization){
                    console.log('productIds',this.productIds)
                    this.active=JSON.parse(this.$route.query.lebel)
                    this.childrenModel=this.productIds
				}	
			},

            showOrHide(){
                console.log(this.childrenModel)
            },

            getParenMoel(){
                 api
                .getUserProduct(this.getDataList)
                .then(res => {
                    if(res.code === 200) {
                        console.log('获取用户模版信息',res.data)
                        let site=[]
                        res.data.models.forEach(p => {
                            p.checked01=false
                            p.products.forEach(k => {
                                k.checked02=false
                                k.children.forEach(j => {
                                    j.checked03=false
                                    site.push(j.country)
                                })
                            })
                        })
                        site=[...new Set(site)]
                        this.siteOptions=site.map(p => {
                            return {
                                label:p,
                                value:p
                            }
                        })
                        this.siteOptions.unshift({
                            label:'all',
                            value:'all'
                        })
                        console.log(site)
                        this.childrenModel=res.data.models
                    }
                })
            },
			

		
	
			//获取导入商品页面的数据
			getShopItems01() {
				this.getDataList.categoryIds=this.chooseParams.length == 1  ? null : this.chooseParams
				this.getDataList.offset=this.offset
				this.getDataList.page=this.currentPage
				this.getDataList.userId=this.userId
				this.getDataList.shopIds= [this.chooseParams[0]]
				this.getDataList.status=this.productStatua
				this.getDataList.itemName=''

				this.getShopAllItems(this.getDataList)
			},


            showCountry(id){
                return utils.showshopNameByshopIdOne(id)
            },

		

		
	

			
			
			//控制每页显示订单条数
			handleSizeChange(val) {
							 console.log(`每页 ${val} 条`);
							 this.offset=parseInt(`${val}`)
							 this.getDataList.offset=parseInt(`${val}`)
							 this.handleCurrentChange()
			  },
			  //显示当前第几页
			  handleCurrentChange(val) {
						this.currentPage=(parseInt(`${val}`) -1) * this.offset
						this.getDataList.page=this.currentPage
						 this.getShopAllItems(this.getDataList)
						 this.currentPage=0
			  },

              getTime(item){
                  return utils.renderTime(item)
              },
              next(num){
                  if(num == 0){
                      this.active--
                  }else{
                      this.active++
                  }
                  console.log(this.active)
                  
              }
		
	


		}
	}
</script>

<style lang="scss" scoped>
.templateEditor{

    // flex:1;
    // margin: 50px 0 0 223px;
    box-sizing: border-box;
    min-height: 100vh;
    padding: 0 20px;
    padding-bottom: 60px;
    background-color: #eee;

    .first_hader{
        position: fixed;
        top: 50px;
        left:223px;
        width: 86%;
        background-color: #fff;
        padding: 15px 10px;
        box-shadow:  0 2px 1px -1px rgba(0,0,0,0.2);
        z-index: 9;


        .second_header{
            display: flex;
            justify-content: space-between;
        }

        .btn{
            margin: 0 5px;
        }

        .check_header{
            margin-bottom: 15px;
        }

        .second_header{
            display: flex;
            
        }

        .third_header{
            margin-top: 15px;

            .third_header_item{
                padding:0 10px
            }
        }
    }

  

    .order_Box{
        margin-top: 160px;
        position: relative;

        .no_data{
            width: 100%;
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            text-align: center;
            margin-top: 200px;


            .desc{
                font-size: 18px;
                padding: 0 10px;
            }
        }


        .item_wrapper{
        
        margin-bottom: 20px;
        box-shadow: 0 2px 1px -1px rgba(0,0,0,0.2);
        background-color: #fff;

        .nodata{
            text-align: center;
            padding: 30px 0;
        }

        .parent_item{
            height: 50px;
            line-height: 50px;
            font-size: 22px;
            border-bottom: 1px #eee solid;
            display: flex;
            justify-content: space-between;

            .parent_desc{
                margin-left: 25px;
                padding: 0 10px;
                font-size: 16px;
                color: #409eff;
                cursor: pointer;
            }
        }

        .item_header_wrapper{
          box-sizing: border-box;
          padding: 5px 10px;
          margin: 10px;
         
        }

        .item_header{
        height: 30px;
        border-bottom: 1px solid #efefef;
        line-height: 30px;
        font-size: 16px;
        padding: 5px 10px;
        color:#409eff ;
        cursor: pointer;

        .header_item{
            margin-right: 15px;
        }
        }


        .chilrder_content{
            border: 5px solid #eee;
           
            margin: 0 15px;
        }

        

        .main_content{
            box-sizing: border-box;
            margin: 3px 0;
            display: flex;

            .item_right{
                width: 70%;
            }
          
           

            .pic_box{
            width: 120px;
        
            }

            .item_left{
                width: 30%;
                display: flex;
                border-right: 1px solid #efefef;

                .item_name{
                   box-sizing: border-box;
                    padding:0 10px
                }
            }

           

         

               


                 .item_center{
                        width: 14%;
                        border-right: 1px solid #efefef;
                        padding: 0 10px;
                        display: flex;
                        flex-direction: column;
                     
                        justify-content: space-between;


                        .desc_item{
                            padding: 5px 0;

                            .iconItem{
                                display: inline-block;
                                width: 12px;
                                height: 12px;
                                vertical-align: middle;
                                background-color: #00c853;
                            }

                            .iconItem_copy{
                                display: inline-block;
                                width: 12px;
                                height: 12px;
                                margin: 0 5px;
                                vertical-align: middle;
                                background-color: #616161;
                            }
                        }

                        .edito_wrapper{
                            margin:0 5px;
                            color:#409eff;
                            cursor: pointer;
                        }
                    }

            

           

    
                .ttp{
                    display: flex;
                    justify-content: flex-start;
                    border-bottom: 1px solid #efefef;
                    margin: 4px 0;

                    .ttp_item:nth-child(1){
                        width: 30%;
                        border-right: 1px solid #efefef;
                       
                    }

                    .ttp_item:nth-child(2){
                        width: 30%;
                        border-right: 1px solid #efefef;
                         padding-left: 10px;
                    }

                    .ttp_item:nth-child(3){
                        width: 20%;
                        border-right: 1px solid #efefef;
                         padding-left: 10px;
                    }

                    .ttp_item:nth-child(4){
                        width: 20%;
                         padding-left: 10px;
                    }
                }
            
        }

    }


    }

     /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;
  }


  /deep/ .el-checkbox__label{
      font-size: 20px;

  }

//   /deep/ .el-input__inner {

//     height: 28px;
//     line-height: 28px;
//     width: 100%;
// }

/deep/ .el-form-item{
    margin-bottom: 0;
}

  
   

    .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}

}

	
	

</style>
